module.exports = __webpack_public_path__ + "img/wave-background.be161112.svg";